var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSparkleAiColor = function SvgSparkleAiColor(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sparkle-ai-color_svg__a)",
    d: "M4.687.837a1 1 0 0 0-1.974 0c-.1.608-.32 1.015-.598 1.29-.279.277-.686.489-1.278.586a1 1 0 0 0 0 1.974c.608.1 1.015.32 1.29.598.277.279.489.686.586 1.278a1 1 0 0 0 1.974 0c.097-.592.31-1 .586-1.278.275-.279.682-.498 1.29-.598a1 1 0 0 0 0-1.974c-.608-.1-1.015-.32-1.29-.598-.277-.279-.489-.686-.586-1.278Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sparkle-ai-color_svg__b)",
    d: "M11.892.874a1 1 0 0 0-1.984 0c-.322 2.534-1.006 4.36-2.118 5.642-1.098 1.265-2.714 2.115-5.145 2.496a1 1 0 0 0 0 1.976c2.431.381 4.047 1.231 5.145 2.496 1.112 1.281 1.796 3.108 2.118 5.642a1 1 0 0 0 1.984 0c.322-2.534 1.006-4.36 2.118-5.642 1.098-1.265 2.714-2.115 5.145-2.496a1 1 0 0 0 0-1.976c-2.563-.402-4.181-1.306-5.248-2.585-1.086-1.304-1.706-3.12-2.015-5.553Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "sparkle-ai-color_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-11.7222 -13.5455 64.3881 -39.9541 14.5 14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF56FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#CE577F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#EA580C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#EF981D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3D42C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sparkle-ai-color_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-11.7222 -13.5455 64.3881 -39.9541 14.5 14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF56FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#CE577F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#EA580C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#EF981D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3D42C"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSparkleAiColor);
export default ForwardRef;